// extracted by mini-css-extract-plugin
export default {"listContainer":"t1zfO8u1ePQrvAhhpmvo","whiteText":"CCGR8Xj5t0g0TcvALtyA","list":"A2MMspIjobRwcGydWJSR","listTitle":"u7taOK6tj56k94KNO81g"};